import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Layout, GetInfo } from "../components";

const RaceVideos = () => {
  const { slug } = useParams();
  const [contentId, setContentId] = useState(0);

  useEffect(() => {
    const urlDictionary = {
      "2023-punta-cana": 147,
    };

    setContentId(urlDictionary[slug]);
  }, [slug]);

  // if (content === null) return;

  return (
    <div className="RaceVideos">
      <Layout bannerId={76}>
        <div className="container">
          <GetInfo id={147} />
        </div>
      </Layout>
    </div>
  );
};

export default RaceVideos;
